import Rewards from 'components/Basket/Rewards/Rewards';
import withRewardsProps from 'viewModel/basket/rewards/withRewardsProps';

const ConnectedRewards = withRewardsProps(Rewards);

export default ConnectedRewards;
